module.exports = __webpack_public_path__ + "img/card.45a158c1.svg";